import React, { Fragment } from "react";
import { Popover, Transition } from "@headlessui/react";

function BasicPopup({ children, button }) {
  return (
    <Popover className="relative flex">
      <Popover.Button className="outline-0 hover:shadow-lg">
        {button}
      </Popover.Button>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-200"
        enterFrom="opacity-0 translate-y-1"
        enterTo="opacity-100 translate-y-0"
        leave="transition ease-in duration-150"
        leaveFrom="opacity-100 translate-y-0"
        leaveTo="opacity-0 translate-y-1"
      >
        <Popover.Panel className="w-screen absolute left-1/2 z-10 mt-5 flex max-w-max -translate-x-1/2 translate-y-16 px-4">
          <div className="p-3 flex-auto overflow-hidden rounded-2xl bg-white leading-6 shadow-xl">
            {children}
          </div>
        </Popover.Panel>
      </Transition>
    </Popover>
  );
}

export default BasicPopup;
